module.exports = __webpack_public_path__ + "static/media/arborea7.4a25da40.jpg";